import { type NextPage } from "next";

import Error404Page from "@moment/app/components/Error404Page";
import { withAppShell } from "@moment/app/components/withAppShell";

export const NotFound: NextPage = () => {
	return <Error404Page />;
};

export default withAppShell(NotFound);
